import React from "react"

import { IconButton, IconButtonTypeMap, Tooltip } from "@mui/material"

export const FuncButton = (props: {
	label: string
	onClick: () => void
	icon: React.ReactElement
	color?: IconButtonTypeMap["props"]["color"]
}) => (
	<Tooltip title={props.label} placement="bottom-start" enterDelay={1000} leaveDelay={100}>
		<IconButton aria-label={props.label} size="medium" onClick={props.onClick} color={props.color}>
			{props.icon}
		</IconButton>
	</Tooltip>
)
